var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinManArmBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "77px",
    height: "39px",
    viewBox: "0 0 77 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CoinManArmBack") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CoinManArmBack",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M76.8388107,36.1919452 L76.8388107,36.1919452 C76.3046811,37.6808136 74.6418248,38.3948841 73.1402153,37.7781868 L67.9299324,35.6338813 C66.4283228,35.017184 65.6321674,33.2958762 66.166297,31.8091019 L66.166297,31.8080548 C66.6903487,30.3191864 68.3532049,29.6051159 69.8548145,30.2218132 L75.0650973,32.3661187 C76.5667069,32.982816 77.3628623,34.7041238 76.8388107,36.1919452",
    id: "Fill-30",
    fill: "#ED5353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.147677,19.1631912 C41.2130463,20.4745744 52.6638207,24.086844 71.5,30 C71.5,30 68.8040871,33.7677625 67.9299324,35.6338813 C66.6105905,38.450372 48.6611223,33.3754671 32,27.5748693 C13.8260592,21.2475812 0,14 0,14 L5.03573698,0 C5.03573698,0 31.049623,17.1961164 37.147677,19.1631912 Z",
    id: "Fill-217",
    fill: "#4E62E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinManArmBack);
export default __webpack_public_path__ + "static/media/CoinManArmBack.950ff35e98f858552829e4c39406e75f.svg";
export { ForwardRef as ReactComponent };